export default __webpack_public_path__ + "static/media/medecine.6b960ca0.svg";